import React from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { CreateInvoiceTemplateMenu } from "./CreateInvoiceTemplateMenu";

interface Props {
    variant: "filtered" | "empty";
    onClearFilters: () => void;
    onCreateNew?: () => void;
    onCreateFromInvoice?: () => void;
}

export const InvoiceTemplatesEmptyView: React.FC<Props> = ({
    variant,
    onClearFilters,
    onCreateNew,
    onCreateFromInvoice,
}) => {
    if (variant === "filtered") {
        return (
            <EmptyState
                header="The filters don't match any templates."
                action={onClearFilters}
            />
        );
    }

    const canCreate = !!onCreateNew && !!onCreateFromInvoice;

    return (
        <EmptyState
            header="No templates yet."
            body="Create a template to reuse on new invoices."
            cta={
                canCreate ? (
                    <CreateInvoiceTemplateMenu
                        onCreateNew={onCreateNew}
                        onCreateFromInvoice={onCreateFromInvoice}
                        align="center"
                    />
                ) : undefined
            }
        />
    );
};
